import { WorkaroundComponent, dashedVariant } from '@gef-ui/material-theme-utils/Paper';
export default function Paper(theme) {
    return {
        MuiPaper: {
            defaultProps: {
                elevation: 0,
                radius: 0.5,
                component: WorkaroundComponent
            },
            styleOverrides: {
                root: {
                    variants: [
                        {
                            props: {
                                variant: 'outlined'
                            },
                            style: {
                                borderColor: theme.palette.grey[500_12]
                            }
                        },
                        {
                            props: {
                                variant: 'error'
                            },
                            style: {
                                boxShadow: theme.customShadows.error,
                                border: `1px solid ${theme.palette.error.main}`
                            }
                        },
                        dashedVariant
                    ]
                },
                rounded: ({ ownerState, theme })=>({
                        borderRadius: theme.radius(ownerState.radius)
                    })
            }
        }
    };
}
